export default {
	type: 'object',
	properties: {
		userId: { type: 'string' },
		campaignId: { type: 'string' },
	},
	required: ['userId', 'campaignId'],
	additionalProperties: false,
}
